import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_COMPACT, colors, borderRadius } from '@/styles';

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export const filterStyles = css`
  background-color: ${token('color.background.neutral', colors.N10A)};
  padding: ${SPACE_COMPACT}px ${SPACE_COMPACT}px;
  ${borderRadius};
  label:focus-within {
    border-color: rgba(0, 0, 0, 0); // need this placeholder to occupy space
  }
`;

export const filterTitleStyles = css`
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
`;
